export default __webpack_public_path__ + "static/sql-light-7cf9c1654de25b6bb07065bf89d2a763.png";